import { createGlobalStyle } from 'styled-components';
import { UI_LAYERS } from '@keen.io/ui-core';
var GlobalStyles = createGlobalStyle(["", "{position:absolute;top:0;left:0;width:100%;z-index:", ";}"], function (props) {
  return props.modalContainer;
}, UI_LAYERS.modal);
export default GlobalStyles;